// extracted by mini-css-extract-plugin
export default {"dataGridItem":"payReport_dataGridItem__UaVIC","partnerColumn":"payReport_partnerColumn__qKBs2","dataGrid":"payReport_dataGrid__pFz3b"};